import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";

export function RequestDialog({ tutor, onClose, onDone }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const blocked = !!tutor && user !== null && (!user || user.role !== "student");
  useEffect(() => {
    if (!blocked) return;
    toast.info("Please log in as a student to request a session");
    onClose();
    nav("/login/student");
  }, [blocked, onClose, nav]);
  if (blocked) return null;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/requests", { tutor_id: tutor.id, message: msg });
      toast.success(`Request sent to ${tutor.name}. Status: Pending`);
      setMsg("");
      onDone?.();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={!!tutor} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="request-session-dialog">
        <DialogHeader>
          <DialogTitle>Request coaching with {tutor?.name}</DialogTitle>
          <DialogDescription>The tutor will review your request. Once approved, they can schedule live sessions for you (100 credits per completed session).</DialogDescription>
        </DialogHeader>
        <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} maxLength={500} placeholder="What would you like help with? (optional)" data-testid="request-message-input" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="request-cancel-button">Cancel</Button>
          <Button onClick={submit} disabled={busy} className="bg-[#1F6FFF] hover:bg-[#1450C9]" data-testid="request-submit-button">{busy && <Spinner />} Send request</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
